/*
  Catálogo PÚBLICO de membresías FHC — landings y web pública.

  Reglas (Samuel, 10/10/2026, sustituye a la de mostrar el precio oficial):
    - En la web pública NO aparece ningún precio ni cuota (ni «IVA», ni «/año»). Las membresías se
      presentan por lo que incluyen y SIEMPRE con un CTA al test de idoneidad; tras el test, el lead
      agenda una llamada y ahí se explica la cuota del nivel que le encaja.
    - Las ofertas (plaza vitalicia, upgrades) tampoco son públicas: llamada y plataforma tras el registro.
    - Se vende pertenencia, acceso a oportunidades (sin cifras), formación, comunidad, certificación
      privada, sesiones y eventos. Nada de inversión, rentabilidad, retorno, tokens ni FHCT.
    - Certificación = privada e interna del club, sin equivalencia académica oficial.

  IDs internos (no cambiar): starter = Access · basica = PRO · premium = Premium.
  El precio que se cobra dentro de la plataforma vive en el backend (routes/memberships.py) y solo
  se muestra en /dashboard, tras el registro.
*/

export const PUBLIC_PLANS = {
  starter: {
    id: 'starter',
    name: 'Access',
    tagline: 'La puerta de entrada al club: comunidad privada, contenidos introductorios y sesiones online.',
    features: [
      'Pertenencia al club y a la comunidad privada',
      'FHC Academy · contenidos introductorios',
      'Sesiones online del club',
      'Recursos y newsletter del club',
      'Networking entre miembros y profesionales',
      'Soporte en un máximo de 48 h laborables',
    ],
  },
  basica: {
    id: 'basica',
    name: 'PRO',
    tagline: 'Formación avanzada, sesiones especializadas en directo y recursos ampliados.',
    features: [
      'Todo lo de Access',
      'FHC Academy · formación avanzada',
      'Sesiones especializadas en directo',
      'Recursos ampliados',
      'Soporte en un máximo de 24 h laborables',
    ],
  },
  premium: {
    id: 'premium',
    name: 'Premium',
    tagline: 'Todo lo de PRO más el Bootcamp Broker Digital presencial, la certificación privada FHC y acompañamiento grupal.',
    features: [
      'Todo lo de PRO',
      'Bootcamp Broker Digital · 4 días presenciales',
      'Certificación privada FHC como Broker Digital',
      'Acompañamiento grupal semanal en directo',
    ],
  },
};

export const PLAN_ORDER = ['starter', 'basica', 'premium'];

// CTA único de la web pública y respuesta estándar a «¿cuánto cuesta?»
export const TEST_CTA = 'Hacer el test de idoneidad';
export const TEST_CTA_EN = 'Take the suitability test';
export const PRICE_ANSWER = 'Cada membresía tiene su cuota anual. Te la explicamos en una llamada breve con el equipo, después de hacer el test de idoneidad, para recomendarte el nivel que de verdad encaja contigo.';
export const PRICE_ANSWER_EN = 'Each membership has its own annual fee. We explain it in a short call with the team, after you take the suitability test, so we can recommend the level that truly fits you.';
export const NEXT_STEP_NOTE = 'Primero, el test de idoneidad (menos de 2 minutos). Después, eliges día y hora para una llamada con el equipo.';

export const BOOTCAMP_NOTE = 'El Bootcamp está sujeto a calendario, aforo y ubicación, y no incluye alojamiento ni dietas.';

export const CERT_NOTE = 'La certificación FHC es privada e interna del club, sin equivalencia académica oficial.';

export const SATISFACTION_NOTE = 'Período de satisfacción de 15 días: si el club no es lo que esperabas, escríbenos y estudiaremos tu caso.';

export const PAYMENT_NOTE = 'Pago con tarjeta o transferencia bancaria.';

export const FEE_SCOPE_NOTE = 'La cuota corresponde exclusivamente al acceso al club, la comunidad privada, los contenidos formativos, las sesiones y los eventos incluidos en el nivel contratado.';
